import { Tab } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { AcquisIfapmeApi } from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { BackButton, PageBase, ProtectedTabs } from "../../../../../components";
import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";
import { AcquisIfapmeDetailPage } from "./AcquisIfapmeDetailPage";

export interface IAcquisIfapmeItemPageProps {}

export const AcquisIfapmeItemPage: React.FunctionComponent<IAcquisIfapmeItemPageProps> = () => {
  const { t } = useTl();
  const history = useHistory();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const AcquisApi = useApiService(AcquisIfapmeApi);
  const [displayName] = useApiEffect(() => AcquisApi.acquisIfapmeGetDisplayName({ id: +id }), [id]);
  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.AcquisIfapme), route: ERoutes.acquisIfapme },
        { text: id === "0" ? t(ETLCodes.New) : displayName }
      ]}
    >
      <ProtectedTabs
        id="TabsAcquisIfapme"
        onChange={newTabId => history.push(`${ERoutes.acquisIfapme}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.acquisIfapme}></BackButton>
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<AcquisIfapmeDetailPage editMode={state === "edit"} id={+id} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
